<!--
  KP-3919 kill switch: this is the Download Catalogue modal exactly as it
  shipped before KP-3919 — a format radio and a Start Download button. It is
  rendered whenever the brand-catalogue flag is OFF, so turning the flag off
  restores the previous behaviour rather than approximating it. Do not
  "improve" this file; its whole value is being unchanged.
-->
<template>
  <v2-modal
    :show="show"
    title="Download Catalogue"
    size="sm"
    @close="$emit('close')"
  >
    <div class="v2-download-catalog">
      <div class="v2-download-catalog__option">
        <label class="v2-download-catalog__label">
          <input
            type="radio"
            name="exportType"
            :value="downloadOption.XLSX"
            :checked="exportType === downloadOption.XLSX"
            class="v2-download-catalog__radio"
            @change="onSelectType"
          >
          <span class="v2-download-catalog__text">Download Excel</span>
        </label>
      </div>
      <v2-button
        block
        :loading="downloading"
        :disabled="downloading"
        class="v2-mt-4"
        @click="downloadCatalogue"
      >
        {{ downloading ? 'Downloading...' : 'Start Download' }}
      </v2-button>
    </div>
  </v2-modal>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'
import constants, { DOWNLOAD_TYPES, FILE_FORMATS } from '@/constants'
import { apiToastSuccess } from '@/@core/utils/toast'
import { DOWNLOAD_COLLECTION } from '@/store/modules/collection.module'
import { SHOW_DOWNLOADS_NAV_INDICATOR } from '@/store/modules/notification.module'

const downloadOption = constants.DOWNLOAD_OPTIONS.CATALOG

export default {
  name: 'V2DownloadCatalogModalLegacy',
  components: { V2Modal, V2Button },
  props: {
    show: { type: Boolean, default: false },
    collection: { type: Object, default: () => null },
    retailerId: { type: String, default: null },
  },
  data() {
    return {
      downloading: false,
      downloadOption,
      exportType: downloadOption.XLSX,
    }
  },
  methods: {
    onSelectType(event) {
      this.exportType = event.target.value
    },
    downloadCatalogue() {
      this.downloading = true
      const payload = {
        downloadType: DOWNLOAD_TYPES.COLLECTION_EXPORT.VALUE,
        respectiveId: this.collection._id,
        fileType: FILE_FORMATS.XLSX,
      }
      if (this.retailerId) {
        payload.retailerId = this.retailerId
      }
      this.$store
        .dispatch(DOWNLOAD_COLLECTION, { payload })
        .then(res => {
          apiToastSuccess(res.data.message)
          this.downloading = false
          this.$store.commit(SHOW_DOWNLOADS_NAV_INDICATOR)
          this.$emit('close')
        })
        .catch(() => {
          this.downloading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-download-catalog {
  &__option {
    padding: var(--v2-space-2) 0;
  }

  &__label {
    display: flex;
    align-items: center;
    gap: var(--v2-space-2);
    cursor: pointer;
    width: 100%;
    padding: var(--v2-space-3) var(--v2-space-4);
    background: var(--v2-muted);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-md);
    transition: border-color 0.15s ease;

    &:hover {
      border-color: var(--v2-primary);
    }
  }

  &__radio {
    accent-color: var(--v2-primary);
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  &__text {
    font-family: var(--v2-font-sans);
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--v2-foreground);
  }
}

.v2-mt-4 {
  margin-top: var(--v2-space-4);
}
</style>
